import { IMAGE } from '../elements/assets'
import { LINK_FIELD } from '../elements/link'
export const INTEGRATIONS = `
...on integrations_Entry {
  id
  typeHandle

  title
  description
  integrations {
    ... on integration_Entry {
      id
      title
      ${ IMAGE }
      description
      comingSoon
      tags: textTable {
        heading
        text
      }
      ${ LINK_FIELD }
    }
  }
}
`
